import { UserRef } from '$tablet-app/src/app/auth/UserModel';
import { ProfileIcons } from '$tablet-app/src/app/components/ProfileIcons/ProfileIcons';
import Row from '$tablet-app/src/app/components/Row';
import { Text } from '$tablet-app/src/app/components/Text/Text';
import { User } from '@akin-home/amplify';
import React, { FC } from 'react';
import styled from 'styled-components/native';

interface Props {
  users?: (UserRef | User)[];
}

/** Displays the users that are currently shared with */
const StickyNoteSharedWithDisplay: FC<Props> = ({ users }) => {
  return users ? (
    <Row alignItems="center">
      <ProfileIcons profiles={users} preset="overlapRight" displayCount={2} />
      <OwnerText bold>Shared with {users[0]?.name || 'Everyone'}</OwnerText>
    </Row>
  ) : null;
};

const OwnerText = styled(Text)`
  font-size: 14px;
  opacity: 0.8;
  margin-left: 10px;
  text-transform: uppercase;
`;

export default StickyNoteSharedWithDisplay;
